import { createFileRoute } from "@tanstack/react-router";
import Unauthorized from "@/components/Unauthorized";

// Authenticated-but-not-authorized landing. RouteGuard redirects non-admins
// here, so this route MUST be public — otherwise the default-deny gate would
// redirect it to itself in a loop.
export const Route = createFileRoute("/_authenticated/unauthorized/")({
  staticData: { access: "public" },
  component: Unauthorized,
});
